import { WidgetFrameFilters as _WidgetFrameFilters } from "@/components/layout/WidgetFrame/WidgetFrameFilters/WidgetFrameFilters";
import { WidgetFrameSearch } from "@/components/layout/WidgetFrame/components/WidgetFrameSearch";

const WidgetFrameFilters = _WidgetFrameFilters as typeof _WidgetFrameFilters & {
    Search: typeof WidgetFrameSearch;
};

WidgetFrameFilters.Search = WidgetFrameSearch;

export { WidgetFrameFilters };
